var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArticle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.519,
    height: 16.426,
    viewBox: "0 0 18.519 16.426",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1558",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1700",
    d: "M-760.668,413l-5.749,1.145a1.4,1.4,0,0,1-1.649-1.1,1.4,1.4,0,0,1-.027-.275v-13.62a1.4,1.4,0,0,1,1.4-1.4,1.386,1.386,0,0,1,.3.033l5.749,1.26a1.4,1.4,0,0,1,1.1,1.37v11.216A1.4,1.4,0,0,1-760.668,413Z",
    transform: "translate(768.093 -397.743)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1701",
    d: "M-756.982,413l5.748,1.145a1.4,1.4,0,0,0,1.65-1.1,1.4,1.4,0,0,0,.027-.275v-13.62a1.4,1.4,0,0,0-1.4-1.4,1.385,1.385,0,0,0-.3.033l-5.749,1.26a1.4,1.4,0,0,0-1.1,1.37v11.216A1.4,1.4,0,0,0-756.982,413Z",
    transform: "translate(768.076 -397.743)",
    fill: "#3e3e3e"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticle);
export default __webpack_public_path__ + "static/media/article.6d0ffee6759012beee4d8918b74dfbda.svg";
export { ForwardRef as ReactComponent };